export const fileSizeToString = (size: number) => `${Math.ceil(size / 1000)} Kb`;
